<template>
  <div class="container-xl masonry-container d-none d-sm-block">
    <div class="preview-grid">
      <div class="card" v-for="(url, idx) in slideshowPhotos" :key="idx">
        <img class="card-img img-fluid" :src="url" alt="Card image">
      </div>
    </div>
    <ModalSignup :event-name="eventName"/>
  </div>
</template>

<script>
import ModalSignup from '@/components/ModalSignup';

export default {
  components: {
    ModalSignup
  },

  props: {
    eventName: {type: String, required: false},
    photos: {type: Array, required: true}
  },

  computed: {
    slideshowPhotos() {
      let photos = this.photos
      const minLength = 45
      const maxLength = 72
      if (photos) {
        while (photos.length !== 0 && photos.length < minLength) {
          photos.push(...this.photos)
        }
        photos.splice(maxLength - 1)
        return photos
      } else {
        return []
      }


    }
  },

  mounted() {
    this.$bvModal.show('modal-signup')
  }
}
</script>

<style lang="scss">
/* Override background color opacity and remove blur */
.modal-backdrop {
  background-color: rgba(#00001A, 0.72) !important;
  backdrop-filter: saturate(150%) !important;
}

.site-banner {
  display: none !important;
}

</style>
